const MINIFIED_REACT_300_OR_310_REGEX = /minified react error #(300|310)\b/i;
const DEV_RENDERED_MORE_HOOKS_REGEX =
  /rendered more hooks than during the previous render/i;
const DEV_RENDERED_FEWER_HOOKS_REGEX = /rendered fewer hooks than expected/i;
const REACT_ERROR_300_OR_310_URL_REGEX = /react\.dev\/errors\/(300|310)\b/i;

/**
 * Detects React hook-count mismatch errors (#300/#310) in both
 * production-minified and development forms. These errors are almost always
 * Rules of Hooks violations, but in our codebase they have been traced to
 * Next.js's own App Router internals (see vercel/next.js#63121) — the
 * `Router` component contains a conditional `throw unresolvedThenable` above
 * several `useMemo` calls, with an `eslint-disable` comment acknowledging the
 * hook-rule violation. When the externally-mutable flag flips between renders,
 * hook count changes between renders and React throws.
 *
 * Treating this as recoverable lets us remount the affected subtree instead
 * of surfacing the "Application error" page to the user.
 */
export function isHookCountMismatchError(error: {
  message?: string;
  stack?: string;
}): boolean {
  const message = error.message ?? "";
  const stack = error.stack ?? "";

  if (
    MINIFIED_REACT_300_OR_310_REGEX.test(message) ||
    DEV_RENDERED_MORE_HOOKS_REGEX.test(message) ||
    DEV_RENDERED_FEWER_HOOKS_REGEX.test(message)
  ) {
    return true;
  }

  if (
    REACT_ERROR_300_OR_310_URL_REGEX.test(message) ||
    REACT_ERROR_300_OR_310_URL_REGEX.test(stack)
  ) {
    return true;
  }

  return false;
}
